<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      title="我的订单"
      z-index="10"
      @click-left="onBack"
      @click-right="onRight">
      <template #right>
        <van-icon :name="nav_right_icon" size="20"></van-icon>
      </template>
    </van-nav-bar>
    <van-tabs
      v-model="tabActive"
      swipeable
      sticky
      offset-top="46"
      line-height="2"
      @click="onTabClick"
      @change="onTabClick">
      <van-tab
        v-for="(item, index) in tabsList"
        :title="item.title"
        :key="index">
        <div class="container">
          <OrderList :tabObject="item" :dateObject.sync="dateObj"> </OrderList>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 展示日期选择面板 -->
    <van-action-sheet :z-index="99" v-model="isShowSheet" title="日期选择">
      <div class="sheet-bg">
        <!-- 列表信息 -->
        <van-cell-group class="options-list">
          <!-- 开始时间 -->
          <van-cell
            is-link
            v-for="(item, index) in dateList"
            :key="index"
            :class="['menu', index == dateList.length - 1 ? 'last' : '']"
            :title="item.title"
            :value="item.subTitle"
            :formatter="formatter"
            @click="onClickItem(item)">
          </van-cell>
        </van-cell-group>
        <van-button class="sure-btn" block @click="onSure">确定</van-button>
        <van-button class="reset-btn" block @click="onReset">重置</van-button>
      </div>
      <!-- 展示时间选择器 -->
      <van-overlay :show="isShowDatePicker" :z-index="100">
        <div class="datetime-bg">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :title="dateTitle"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirm"
            @cancel="onCancel"></van-datetime-picker>
        </div>
      </van-overlay>
    </van-action-sheet>
  </div>
</template>

<script>
import rightImg from "../../assets/img/my-order/calendar.png"
import {
  ActionSheet,
  CellGroup,
  DatetimePicker,
  Icon,
  Overlay,
  Tab,
  Tabs
} from "vant"
import OrderList from "./orderList.vue"
export default {
  name: "myorder",
  components: {
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [ActionSheet.name]: ActionSheet,
    [CellGroup.name]: CellGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Overlay.name]: Overlay,
    OrderList
  },
  data() {
    return {
      nav_right_icon: rightImg,
      tabActive: 0,
      tabsList: [
        { title: "全部", type: "" },
        { title: "认购", type: "PUR" },
        { title: "提现", type: "WHC" },
        { title: "充值", type: "PCL" }
      ],
      tempBeginTime: "",
      tempEndTime: "",
      dateObj: {},
      isShowSheet: false,
      isShowDatePicker: false,
      minDate: new Date(2000, 1, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      dateTitle: "",
      dateList: [
        { title: "开始时间", subTitle: "请选择" },
        { title: "结束时间", subTitle: "请选择" }
      ]
    }
  },
  mounted() {
    if (this.$route.params && this.$route.params.selectIndex) {
      this.tabActive = this.$route.params.selectIndex
    }
  },
  methods: {
    onTabClick(item) {},
    onBack() {
      this.$router.push({ name: "user" })
    },
    onRight() {
      this.isShowSheet = true
    },
    onClickItem(item) {
      this.isShowDatePicker = true
      this.dateTitle = item.title
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年"
      }
      if (type === "month") {
        return val + "月"
      }
      if (type === "day") {
        return val + "日"
      }
      return val
    },
    onCancel() {
      this.isShowDatePicker = false
    },
    onConfirm(value) {
      if (this.dateTitle == "开始时间") {
        if (this.tempEndTime) {
          if (
            this.estimateRegisterationTime(
              this.timeFormat(value),
              this.tempEndTime
            )
          ) {
            this.tempBeginTime = this.timeFormat(value)
            this.dateList[0]["subTitle"] = this.tempBeginTime
          }
        } else {
          this.isShowDatePicker = false
          this.tempBeginTime = this.timeFormat(value)
          this.dateList[0]["subTitle"] = this.tempBeginTime
        }
      } else if (this.dateTitle == "结束时间") {
        if (this.tempBeginTime) {
          if (
            this.estimateRegisterationTime(
              this.tempBeginTime,
              this.timeFormat(value)
            )
          ) {
            this.tempEndTime = this.timeFormat(value)
            this.dateList[1]["subTitle"] = this.tempEndTime
          }
        } else {
          this.isShowDatePicker = false
          this.tempEndTime = this.timeFormat(value)
          this.dateList[1]["subTitle"] = this.tempEndTime
        }
      }
    },
    timeFormat(time) {
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      if (month < 10) {
        month = "0" + month
      }
      let day = time.getDate()
      return year + "-" + month + "-" + day
    },
    // 判断两个日期是否在一年以内
    estimateRegisterationTime(beginDate, endDate) {
      let begin = new Date(beginDate).getTime()
      let end = new Date(endDate).getTime()
      let day = (end - begin) / (24 * 60 * 60 * 1000)
      if (day > 365) {
        this.$toast("只能选择一年以内的时间，请重新选择")
        return false
      } else {
        if (day < 0) {
          this.$toast("结束时间要大于等于开始时间，请重新选择")
          return false
        } else {
          this.isShowDatePicker = false
          return true
        }
      }
    },
    onSure() {
      this.isShowSheet = false
      this.dateObj = {
        beginTime: this.tempBeginTime,
        endTime: this.tempEndTime
      }
    },
    onReset() {
      this.isShowSheet = false
      this.tempBeginTime = ""
      this.tempEndTime = ""
      this.dateObj = {
        beginTime: "",
        endTime: ""
      }
      this.dateList[0]["subTitle"] = "请选择"
      this.dateList[1]["subTitle"] = "请选择"
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  width: 375px;
}
.options-list {
  // 下边框线条
  ::v-deep .van-cell.menu:not(:last-child)::after {
    border: none;
  }
  ::v-deep .van-cell {
    border-bottom: 1px solid #ebebeb;
    padding: 10px 15px;
    .van-cell__title {
      color: #666;
      font-size: 15px;
    }
  }
  .last {
    border: none;
  }
}
.sure-btn {
  margin-top: 50px;
  left: 15px;
  width: calc(100vw - 30px);
  height: 44px;
  border: 1px solid rgb(226, 152, 56);
  border-radius: 6px;
  color: rgb(226, 152, 56);
}
.reset-btn {
  margin-top: 15px;
  margin-bottom: 34px;
  left: 15px;
  width: calc(100vw - 30px);
  height: 44px;
  border: 1px solid rgb(151, 151, 151);
  border-radius: 6px;
  color: rgb(151, 151, 151);
}
.datetime-bg {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
}
</style>>
